// extracted by mini-css-extract-plugin
export default {"wrapper":"action-btns_wrapper__B0KDo"};